
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    clicked() {
      if (!this.disabled) {
        this.$emit('clicked');
      }
    },
  },
};
